import { GenIcon } from '../helpers/IconBase.es.js';

const QaOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 18.4546C12.5523 18.4546 13 18.0069 13 17.4546C13 16.9023 12.5523 16.4546 12 16.4546C11.4477 16.4546 11 16.9023 11 17.4546C11 18.0069 11.4477 18.4546 12 18.4546ZM10.3513 7.74078C11.1422 7.39128 12.0464 7.24131 12.8171 7.31365C13.6061 7.38772 14.1113 7.67378 14.3347 8.0354C14.8461 8.86293 14.6033 9.96445 13.3706 11.0089C12.0205 12.1529 11.25 12.9835 11.25 14.273C11.25 14.6872 11.5858 15.023 12 15.023C12.4142 15.023 12.75 14.6872 12.75 14.273C12.75 13.7443 12.9631 13.3203 14.3403 12.1533C15.8349 10.8869 16.6903 8.9939 15.6107 7.24689C15.0388 6.32123 13.9817 5.91638 12.9573 5.82022C11.9145 5.72234 10.7542 5.92282 9.74503 6.36878C9.36616 6.53621 9.19476 6.97907 9.36219 7.35793C9.52962 7.7368 9.97248 7.90821 10.3513 7.74078Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { QaOutlined };
